import { format } from 'date-fns';
import TableCellStatus from '../../components/table-cell-status/table-cell-status.component';
import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../utils/column-values.util';
import { useMediaQuery } from 'react-responsive';
import { formatNumberToTwoDecimal } from '../../utils/format-number.util';

export const INVENTORY_REPORT_VALUATION_INFO = {
  reportTitle: "Stock Reports",
  path: "/inventoryreports",
  subPath: "/inventoryvaluation",
  listPage: "/inventory-reports",
  pagePath:"items",
  hasChart: false,
  tableHasGrandTotal: true,
  hasLocationFilter: true,
  hasSearch: true
}

export const INVENTORY_REPORT_VALUATION_COLUMN_TEMPLATE = [
  {
    Header: "Product Code/Name",
    accessor: "itemCodeName",
    Cell: ({ value }) => {
      return displayCellValue(value);
    },
    Footer: 'Total'
  },
  {
    Header: "Category",
    accessor: "category",
    Cell: ({ value }) => {
      return displayCellValue(value);
    },
  },
  {
    Header: "Branch",
    accessor: "locationCode",
    Cell: ({ value }) => {
      return displayCellValue(value);
    },
  },
  {
    Header: "Beginning Qty",
    accessor: "beginningQty",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });

      if (isMobileView) {
        return `Reserve: ${value ? displayCellValueNumberToTwoDecimal(value) : 0}`;
      }

      return value ? displayCellValueNumberToTwoDecimal(value) : 0;
    }
  },
  {
    Header: "Qty on Hand",
    accessor: "qtyOnHand",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });
      const isRightAligned = true;

      if (!value) {
          return displayCellValue(value);
      }

      value.label = value && value.label && isNaN(value.label) ?
          value.label :
          !isMobileView ? formatNumberToTwoDecimal(value.label) : `${formatNumberToTwoDecimal(value.label)} Quantity`


      return (
          <div className={isMobileView && isRightAligned ?
              'list-table__body__row__cell--right-aligned-mobile-cell' : ''}>
              <TableCellStatus
                  value={value}
                  noDot={true}
              />
          </div>
      );
    }
  },
  {
    Header: "Unit Cost",
    accessor: "unitCost",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });

      if (isMobileView) {
        return `Unit Cost: ${value ? displayCellValueNumberToTwoDecimal(value) : 0}`;
      }

      return value ? displayCellValueNumberToTwoDecimal(value) : 0;
    }
  },
  {
    Header: "Total Value (ETB)",
    accessor: "totalValue",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });

      if (isMobileView) {
        return `Total Value: ${value ? displayCellValueNumberToTwoDecimal(value) : 0}`;
      }

      return value ? displayCellValueNumberToTwoDecimal(value) : 0;
    },
    Footer: 'totalValue'
  } 
]
